module.exports = __webpack_public_path__ + "img/icon_guanyuwomen_keji@3x.05a6d2ba.png";